// extracted by mini-css-extract-plugin
export default {"container":"ItaONX3D7DVGwPsYjhm5ig==","illustration":"P1IOmMGDNDN3KFSLSqhf+w=="};